const sourceRecord = (item) => {
  const payload = item?.payload;
  return payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};
};

export const selectLatestSourcingContext = (items) => {
  const timeline = Array.isArray(items) ? items : [];
  const item = [...timeline].reverse().find((entry) => String(entry?.type || '').trim() === 'sourcing_candidates');
  const payload = sourceRecord(item);
  const candidates = Array.isArray(payload.candidates) ? payload.candidates : [];
  return {
    latestSourcingQuery: String(payload.query || '').trim(),
    latestSourcingResultIds: candidates
      .map((candidate) => String(candidate?.result_id || candidate?.id || '').trim())
      .filter(Boolean),
  };
};
